import React from "react";
import { Container } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import NavBar from "../../Components/NavBar";
import api from "../../../Services/Api/api";
import { toLocaleString } from "../../../Modules/utils/etc";
import _ from "lodash";

const SCREEN_NAME = "DASHBOARD_SCREEN";

class DashboardScreen extends AppComponent {
  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      // await this.setAsyncState({ loading: true, error: null });
      // const data = await api.get("v1/report");
      // await this.setAsyncState({ data, loading: false });
    } catch (e) {
      await this.setAsyncState({ loading: false, error: e.message });
    }
  }

  render() {
    const {
      state: { loading, error, data },
      props: { hideLogo = false },
    } = this;

    const content = (
      <div className="dashboard">
        {loading ? <div>Loading..</div> : null}
        {error ? <div className="errormsg">{error}</div> : null}
      </div>
    );

    return (
      <>
        <NavBar activeLink="/" />
        <Container className="gainner">{content}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  hideLogo: state.vState[SCREEN_NAME]?.hideLogo,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardScreen);
